export const pList = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c3_f9354182-0876-4b80-9a04-d6c01cc8b82b.jpg?v=1599117656',
    altText: 'Gobi Cashmere',
    handle: '/collections/damen-kaschmir-79',
    style: 'col-6',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c13_7da316bb-6be2-4d16-b544-9bc6bca4c0b0.jpg?v=1599117657',
    altText: 'boot-ausschnitt-kleid-hellgrau',
    handle: '/products/boot-ausschnitt-kleid-hellgrau',
    style: 'col-6',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c5_1c9ba21f-5b27-4785-8da0-58ec95210976.jpg?v=1599117658',
    altText: 'leichter-basic-pullover-mit-rundausschnitt-taupe',
    handle: '/products/leichter-basic-pullover-mit-rundausschnitt-taupe',
    style: 'col-12',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c6_489a6c1d-63d6-4631-8b4e-6cd3073ace02.jpg?v=1599117657',
    altText: 'leichter-basic-pullover-mit-rundausschnitt-taupe',
    handle: '/products/leichter-basic-pullover-mit-rundausschnitt-taupe',
    style: 'col-6 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c7_31723134-51b0-4f9e-b0af-7faf7e707e30.jpg?v=1599117659',
    altText: 'leichter-basic-pullover-mit-rundausschnitt-taupe',
    handle: '/products/leichter-basic-pullover-mit-rundausschnitt-taupe',
    style: 'col-6',
  },
];
export const pList2 = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c9_48d26f78-b6c3-49a5-8802-a9fb1c331d14.jpg?v=1599117657',
    altText: 'boot-ausschnitt-kleid-eigelb-gelb',
    handle: '/products/boot-ausschnitt-kleid-eigelb-gelb',
    style: 'col-6 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c10_36546b50-da0d-4c02-bb7c-ba3adeafcf4d.jpg?v=1599117658',
    altText: 'boot-ausschnitt-kleid-beige',
    handle: '/products/boot-ausschnitt-kleid-beige',
    style: 'col-6 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c11_d9750af2-6a84-472a-bbfa-2a6d0bbe0439.jpg?v=1599117657',
    altText: 'stehkragenpullover-mit-trichterarmeln-orchideeneis',
    handle: '/products/stehkragenpullover-mit-trichterarmeln-orchideeneis',
    style: 'col-12 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c12_0c6225af-a84a-4e9b-acbd-42a759b138de.jpg?v=1599117656',
    altText: 'drapierter-kaschmir-poncho-beige',
    handle: '/products/drapierter-kaschmir-poncho-beige',
    style: 'col-6 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c18_2faa6058-0371-4b29-a286-a8b81f017676.jpg?v=1599117658',
    altText: 'kaschmir-seide-bademantel-hellgrau',
    handle: '/products/kaschmir-seide-bademantel-hellgrau',
    style: 'col-6 ',
  },
];

export const pList3 = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c15_8ddb1b7f-10c4-4729-977f-b851816974cf.jpg?v=1599117656',
    altText: 'two-way-strickjacke-sequoia',
    handle: '/products/two-way-strickjacke-sequoia',
    style: 'col-6 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c16_2ae62551-b595-4da1-aab2-d5ff2104bfa7.jpg?v=1599117656',
    altText: 'r-ausschnitt-pullover-hellgrau',
    handle: '/products/r-ausschnitt-pullover-hellgrau',
    style: 'col-6 ',
  },
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c17_fbfbe012-d1bb-406d-b708-1fb071e3783e.jpg?v=1599117658',
    altText: 'kapuzenpullover-mit-streifen-gebrochenes-weiss',
    handle: '/products/kapuzenpullover-mit-streifen-gebrochenes-weiss',
    style: 'col-12 ',
  },
];

export const banner1 = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c8_ecf792e6-2c78-4b9c-991f-85de68ea75d4.jpg?v=1599117657',
    altText: 'Gobi Cashmere',
    description: `Mit unserem Kleid aus dem weichsten mongolischen Kaschmir werden Sie bezaubernd aussehen, weil es universell schmeichelhaft für jede Figur entworfen ist. `,
  },
];

export const banner2 = [
  {
    image:
      'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/c14_1efc5dce-6b25-4ef4-bfaf-9e6b43d9a7aa.jpg?v=1599117657',
    altText: 'Gobi Cashmere',
    description:
      'Praktisch. Warm. Kuschelig. Nur bei GOBI findet man Loungewear mit dem Komfort von Pyjamas und dem Stil von Freizeitkleidung.',
  },
];
